import { motion } from "framer-motion";
import heroImage from "./assets/why-img.jpg";

const HeroSection = () => {
  return (
    <section className="relative py-12 overflow-hidden snap-section">

      <div className="absolute top-[-100px] right-[-100px] w-[300px] h-[300px] bg-[#FF7A00]/10 rounded-full blur-[120px]" />

      <div className="max-w-[1200px] mx-auto px-6 flex flex-col lg:flex-row items-center gap-16 relative z-10">

        <motion.div
          initial={{ opacity: 0, x: -80 }}   
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: false, amount: 0.3 }}
          className="flex-1 text-center lg:text-left"
        >
          <p className="text-[#FF7A00] font-semibold mb-4 uppercase tracking-wide">
            Why Choose Winglo
          </p>

          <h1 className="text-3xl md:text-4xl font-bold text-[#212129] mb-6 leading-tight">
            Empowering{" "}
            <span className="text-[#FF7A00]">
              Digital Transformation
            </span>{" "}
            in Healthcare & Education
          </h1>

          <p className="text-gray-600 leading-relaxed mb-10 max-w-[520px] mx-auto lg:mx-0">
            Winglo delivers enterprise-grade platforms designed to streamline
            operations, enhance efficiency, and enable data-driven decision making
            with secure cloud technology.
          </p>

         
          <div className="flex flex-wrap gap-6 justify-center lg:justify-start">

   
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-400 to-pink-500 rounded-2xl blur opacity-20 group-hover:opacity-40 transition" />

              <div className="relative bg-white/80 backdrop-blur-md p-6 rounded-2xl shadow-lg border border-white/40 min-w-[180px] text-center transition group-hover:scale-105">
                <p className="text-sm text-gray-500 mb-1">
                  Trusted By
                </p>
                <h3 className="text-3xl font-bold text-[#FF7A00]">
                  150+
                </h3>
                <p className="text-sm text-gray-600">
                  Institutions
                </p>
              </div>
            </div>

          
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-400 to-pink-500 rounded-2xl blur opacity-20 group-hover:opacity-40 transition" />

              <div className="relative bg-white/80 backdrop-blur-md p-6 rounded-2xl shadow-lg border border-white/40 min-w-[180px] text-center transition group-hover:scale-105">
                <p className="text-sm text-gray-500 mb-1">
                  Years of Experience
                </p>
                <h3 className="text-3xl font-bold text-[#FF7A00]">
                  20+
                </h3>
                <p className="text-sm text-gray-600">
                  Industry Expertise
                </p>
              </div>
            </div>

          </div>
        </motion.div>

  
        <motion.div
          initial={{ opacity: 0, x: 80 }}   
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: false, amount: 0.3 }} 
          className="flex-1 relative"
        >
          <div className="absolute inset-0 bg-[#FF7A00]/10 blur-3xl rounded-full" />

          <motion.img
            src={heroImage}
            alt="Why Choose Winglo"
            className="relative rounded-3xl shadow-2xl"
            animate={{ y: [0, -12, 0] }}
            transition={{
              duration: 5,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />

          <div className="absolute bottom-6 left-6 bg-white px-5 py-3 rounded-xl shadow-lg">
            <p className="text-sm font-semibold text-[#FF7A00]">
              Trusted by Leading Institutions
            </p>
          </div>

        </motion.div>

      </div>
    </section>
  );
};

export default HeroSection;